import { useCurrentUser } from 'api/hooks/useCurrentUser';
import { TenantType } from 'api/models/Users';
import { useEffect } from 'react';

// not `jsd-widget`, which is the id embed.js gives the iframe it creates
export const JSD_WIDGET_SCRIPT_ID = 'jsd-widget-embed';

const JSD_WIDGET_BASE_URL = 'https://jsd-widget.atlassian.com';

/**
 * Loads the Jira Service Management virtual service agent, for hospital tenants only.
 */
export const useJsdWidget = () => {
  const { data: user } = useCurrentUser();
  const isHospitalUser = user?.tenant.type == TenantType.HOSPITAL;
  const widgetId = process.env.REACT_APP_JSD_WIDGET_ID;

  useEffect(() => {
    if (!isHospitalUser || !widgetId || document.getElementById(JSD_WIDGET_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = JSD_WIDGET_SCRIPT_ID;
    script.src = `${JSD_WIDGET_BASE_URL}/assets/embed.js`;
    script.setAttribute('data-jsd-embedded', '');
    script.setAttribute('data-key', widgetId);
    script.setAttribute('data-base-url', JSD_WIDGET_BASE_URL);

    // embed.js only builds the widget from a DOMContentLoaded listener, and we can't add the script
    // until the tenant type has loaded, which is always after that event has fired. Replay it so the
    // listener it just registered actually runs.
    script.onload = () => {
      if (document.readyState != 'loading') document.dispatchEvent(new Event('DOMContentLoaded'));
    };

    document.body.appendChild(script);
  }, [isHospitalUser, widgetId]);
};
